/*
 * Copyright (c) 2021 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	GreenlightTextTools_RemoveTextHighlight.js
 *
 * Description:	The class containing the functionality required by the Greenlight for text tools for a text removal highlight.
 * 
 */

// The text tools object.
var g_oTextTools_RemoveTextHighlight = {};

(function () {
	"use strict";

	/**
	 * Load the remove text highlight tool for the page.
	 */
	function TextTools_RemoveTextHighlight() {

		// For removing highlights, we need to keep a copy of the original highlight, split into its individual items.
		this.g_oSplitHighlightContent = [];
	};

	/**
	 * Initialises a remove text highlight.
	 */
	TextTools_RemoveTextHighlight.prototype.initialiseHighlight = function () {

		// Determine the canvas to highlight on, and the non highlight canvas.
		var oViewer = !g_oTextTools.g_bHighlightOnCompareCanvas ? g_oViewer.g_oArtworkViewer : g_oCompare.g_oCompareViewer;
		var oAnnotationViewer = !g_oTextTools.g_bHighlightOnCompareCanvas ? g_oViewer.g_oAnnotationViewer : g_oCompare.g_oCompareAnnotationViewer;
		var szHighlightCanvas = !g_oTextTools.g_bHighlightOnCompareCanvas ? "AnnotationViewer" : "CompareAnnotationViewer";
		var szNonHighlightCanvas = !g_oTextTools.g_bHighlightOnCompareCanvas ? "CompareAnnotationViewer" : "AnnotationViewer";

		// Split the content into individual items.
		g_oTextTools_RemoveTextHighlight.g_oSplitHighlightContent = g_oTextTools.splitSections(g_oTextTools.g_oAnnotationText, oViewer, oAnnotationViewer);

		// Reset the highlighting to the existing sections.
		g_oTextTools.removeHighlights(oAnnotationViewer);
		g_oTextTools.highlightSections(g_oTextTools_RemoveTextHighlight.g_oSplitHighlightContent, oViewer, oAnnotationViewer);

		// Activate the mouse move event.
		changeCanvasFunction($("#" + szHighlightCanvas), 'pointermove.annotationUI', function (event) {
			g_oTextTools_RemoveTextHighlight.mouseMove(event, oViewer, oAnnotationViewer);
		});

		// Activate the mouse down event.
		changeCanvasFunction($("#" + szHighlightCanvas), 'pointerdown', function (event) {
			g_oTextTools_RemoveTextHighlight.mouseDown(event, oViewer, oAnnotationViewer);
		});

		// Activate the mouse down event for the compare canvas.
		$("#" + szNonHighlightCanvas).css("cursor", "default");
		changeCanvasFunction($("#" + szNonHighlightCanvas), 'pointerdown', function (event) {
			g_oGreenlightMessages.displayWarningBubble(g_oTextTools.c_szHighlightUnavailableCanvas);
		});
	};

	/**
	 * Mouse move event for a remove text highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_RemoveTextHighlight.prototype.mouseMove = function (event, oArtworkCanvas, oAnnotationCanvas) {

		// Search for text.
		var oPosition = g_oTextTools.convertMousePositionToPercentages(event, oArtworkCanvas, oAnnotationCanvas);
		g_oTextTools.g_oCurrentText = g_oTextTools.findText(oPosition.x, oPosition.y, oArtworkCanvas, oAnnotationCanvas);

		// Determine the canvas id.
		var szCanvasId = "#" + (!g_oTextTools.g_bHighlightOnCompareCanvas ? "AnnotationViewer" : "CompareAnnotationViewer");

		// Change the cursor based on if a word was found.
		$(szCanvasId).css("cursor", g_oTextTools.g_oCurrentText == null ? "default" : "text");

		// If we have not found any text, find the closest text.
		if (g_oTextTools.g_oCurrentText == null) {
			g_oTextTools.g_oCurrentText = g_oTextTools.findClosestText(oPosition.x, oPosition.y, oArtworkCanvas, oAnnotationCanvas);
		}

		// If we have still not found any text, highlight the existing sections.
		if (g_oTextTools.g_oCurrentText == null) {
			g_oTextTools.removeHighlights(oAnnotationCanvas);
			g_oTextTools.highlightSections(g_oTextTools_RemoveTextHighlight.g_oSplitHighlightContent, oArtworkCanvas, oAnnotationCanvas);
			return;
		}

		// Create a copy of the annotation text, removing the text we have highlighted.
		var oAnnotationText = g_oTextTools_RemoveTextHighlight.removeTextHighlightFromTextData(deepCopyArray(g_oTextTools_RemoveTextHighlight.g_oSplitHighlightContent), g_oTextTools.g_oCurrentText, g_oTextTools.g_oCurrentText, g_oTextTools.isTextHighlightLeftToRight(), oArtworkCanvas, oAnnotationCanvas);

		// Highlight the remaining words.
		g_oTextTools.removeHighlights(oAnnotationCanvas);
		g_oTextTools.highlightSections(oAnnotationText, oArtworkCanvas, oAnnotationCanvas);
	};

	/**
	 * Mouse down event for a remove text highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_RemoveTextHighlight.prototype.mouseDown = function (event, oArtworkCanvas, oAnnotationCanvas) {

		// Search for text.
		var oPosition = g_oTextTools.convertMousePositionToPercentages(event, oArtworkCanvas, oAnnotationCanvas);
		g_oTextTools.g_oCurrentText = g_oTextTools.findText(oPosition.x, oPosition.y, oArtworkCanvas, oAnnotationCanvas);

		// If we have not found any text, find the closest text.
		if (g_oTextTools.g_oCurrentText == null) {
			g_oTextTools.g_oCurrentText = g_oTextTools.findClosestText(oPosition.x, oPosition.y, oArtworkCanvas, oAnnotationCanvas);
		}

		// Ensure we have moused down on text.
		if (g_oTextTools.g_oCurrentText == null) {
			g_oGreenlightMessages.displayWarningBubble(g_oTextTools.c_szNoLiveTextFound);
			return;
		}

		// Update the starting and ending text.
		g_oTextTools.g_oStartingText = g_oTextTools.g_oEndingText = g_oTextTools.g_oCurrentText;

		// Create a copy of the annotation text, removing the text we have highlighted.
		var oAnnotationText = g_oTextTools_RemoveTextHighlight.removeTextHighlightFromTextData(deepCopyArray(g_oTextTools_RemoveTextHighlight.g_oSplitHighlightContent), g_oTextTools.g_oStartingText, g_oTextTools.g_oEndingText, g_oTextTools.isTextHighlightLeftToRight(), oArtworkCanvas, oAnnotationCanvas);

		// Highlight the remaining words.
		g_oTextTools.removeHighlights(oAnnotationCanvas);
		g_oTextTools.highlightSections(oAnnotationText, oArtworkCanvas, oAnnotationCanvas);

		// Clear all bindings.
		changeCanvasFunction();

		// Determine the canvas we are currently on.
		var szCurrentCanvas = !g_oTextTools.g_bHighlightOnCompareCanvas ? "AnnotationViewer" : "CompareAnnotationViewer";

		// Change the cursor to text.
		$("#" + szCurrentCanvas).css("cursor", "text");

		// Set the mouse drag event.
		changeCanvasFunction($("#" + szCurrentCanvas), 'pointermove.annotationUI', function (event) {
			g_oTextTools_RemoveTextHighlight.mouseDrag(event, oArtworkCanvas, oAnnotationCanvas);
		});

		// Set the mouse up event.
		changeCanvasFunction($("#" + szCurrentCanvas), 'pointerup', function (event) {
			g_oTextTools_RemoveTextHighlight.mouseUp(event, oArtworkCanvas, oAnnotationCanvas);
		});
	};

	/**
	 * Mouse drag event for a remove text highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_RemoveTextHighlight.prototype.mouseDrag = function (event, oArtworkCanvas, oAnnotationCanvas) {

		// Search for text.
		var oPosition = g_oTextTools.convertMousePositionToPercentages(event, oArtworkCanvas, oAnnotationCanvas);
		g_oTextTools.g_oCurrentText = g_oTextTools.findText(oPosition.x, oPosition.y, oArtworkCanvas, oAnnotationCanvas);

		// If we have not found any text, find the closest text.
		if (g_oTextTools.g_oCurrentText == null) {
			g_oTextTools.g_oCurrentText = g_oTextTools.findClosestText(oPosition.x, oPosition.y, oArtworkCanvas, oAnnotationCanvas);
		}

		// Check a word has been found.
		if (g_oTextTools.g_oCurrentText == null) {
			return;
		}

		// Update the ending word for the highlight.
		g_oTextTools.g_oEndingText = g_oTextTools.g_oCurrentText;

		// Create a copy of the annotation text, removing the text we have highlighted.
		var oAnnotationText = g_oTextTools_RemoveTextHighlight.removeTextHighlightFromTextData(deepCopyArray(g_oTextTools_RemoveTextHighlight.g_oSplitHighlightContent), g_oTextTools.g_oStartingText, g_oTextTools.g_oEndingText, g_oTextTools.isTextHighlightLeftToRight(), oArtworkCanvas, oAnnotationCanvas);

		// Highlight the remaining words.
		g_oTextTools.removeHighlights(oAnnotationCanvas);
		g_oTextTools.highlightSections(oAnnotationText, oArtworkCanvas, oAnnotationCanvas);
	};

	/**
	 * Mouse up event for a remove text highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_RemoveTextHighlight.prototype.mouseUp = function (event, oArtworkCanvas, oAnnotationCanvas) {

		// Create a copy of the annotation text, removing the text we have highlighted.
		var oAnnotationText = g_oTextTools_RemoveTextHighlight.removeTextHighlightFromTextData(deepCopyArray(g_oTextTools_RemoveTextHighlight.g_oSplitHighlightContent), g_oTextTools.g_oStartingText, g_oTextTools.g_oEndingText, g_oTextTools.isTextHighlightLeftToRight(), oArtworkCanvas, oAnnotationCanvas);

		// Ensure we still have words remaining.
		if (oAnnotationText.length == 0) {
			g_oGreenlightMessages.displayWarningBubble("All text cannot be removed.");
			g_oTextTools.initialiseTextTool(g_oTextTools.g_eToolTypes.RemoveTextHighlight, g_oTextTools.g_eActiveAnnotationType, g_oTextTools.g_bHighlightIsCharacterAccuracy, g_oTextTools.g_bHighlightOnCompareCanvas, g_oTextTools.g_szHighlightColour);
			return;
		}

		// Merge the split content.
		var oMergedAnnotationText = g_oTextTools.mergeSections(oAnnotationText, oArtworkCanvas, oAnnotationCanvas);

		// Update the text.
		g_oTextTools.g_oAnnotationText = oMergedAnnotationText;
		g_oTextTools.initialiseTextTool(g_oTextTools.g_eToolTypes.RemoveTextHighlight, g_oTextTools.g_eActiveAnnotationType, g_oTextTools.g_bHighlightIsCharacterAccuracy, g_oTextTools.g_bHighlightOnCompareCanvas, g_oTextTools.g_szHighlightColour);
	};

	/**
	 * Removes a text highlight from text data.
	 * @param {object} oTextData - The text data.
	 * @param {object} startingText - The starting text.
	 * @param {object} endingText - The ending text.
	 * @param {bool} leftToRight - If the highlight is right to left.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_RemoveTextHighlight.prototype.removeTextHighlightFromTextData = function (oTextData, startingText, endingText, leftToRight, oArtworkCanvas, oAnnotationCanvas) {
		return g_oTextTools.g_bHighlightIsCharacterAccuracy ? g_oTextTools_RemoveTextHighlight.removeTextHighlightFromTextData_Characters(oTextData, startingText, endingText, leftToRight, oArtworkCanvas, oAnnotationCanvas) : g_oTextTools_RemoveTextHighlight.removeTextHighlightFromTextData_Words(oTextData, startingText, endingText, leftToRight, oArtworkCanvas, oAnnotationCanvas);
	};

	/**
	 * Removes a word text highlight from text data.
	 * @param {object} oTextData - The text data.
	 * @param {object} startingText - The starting text.
	 * @param {object} endingText - The ending text.
	 * @param {bool} leftToRight - If the highlight is right to left.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_RemoveTextHighlight.prototype.removeTextHighlightFromTextData_Words = function (oTextData, startingText, endingText, leftToRight, oArtworkCanvas, oAnnotationCanvas) {

		// Get the words for the section.
		var oTextHighlightWords = g_oTextTools.getSectionWords(startingText, endingText, leftToRight, oArtworkCanvas, oAnnotationCanvas);

		// Loop through each word in the text data.
		for (var i = 0; i < oTextData.length; i++) {

			// Check if this word needs to be removed.
			var bWordRemoved = false;
			for (var j = 0; j < oTextHighlightWords.length; j++) {
				if (oTextData[i].startingText.paragraph == oTextHighlightWords[j].paragraph &&
					oTextData[i].startingText.line == oTextHighlightWords[j].line &&
					oTextData[i].startingText.word == oTextHighlightWords[j].word) {
					bWordRemoved = true;
					break;
				}
			}

			// Remove the word if required.
			if (bWordRemoved) {
				oTextData.splice(i, 1);
				i--;
			}
		}

		// Return the result.
		return oTextData;
	};

	/**
	 * Removes a character text highlight from text data.
	 * @param {object} oTextData - The text data.
	 * @param {object} startingText - The starting text.
	 * @param {object} endingText - The ending text.
	 * @param {bool} leftToRight - If the highlight is right to left.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_RemoveTextHighlight.prototype.removeTextHighlightFromTextData_Characters = function (oTextData, startingText, endingText, leftToRight, oArtworkCanvas, oAnnotationCanvas) {

		// Get the characters for the section.
		var oTextHighlightCharacters = g_oTextTools.getSectionCharacters(startingText, endingText, leftToRight, oArtworkCanvas, oAnnotationCanvas);

		// Loop through each character in the text data.
		for (var i = 0; i < oTextData.length; i++) {

			// Check if this character needs to be removed.
			var bCharacterRemoved = false;
			for (var j = 0; j < oTextHighlightCharacters.length; j++) {
				if (oTextData[i].startingText.paragraph == oTextHighlightCharacters[j].paragraph &&
					oTextData[i].startingText.line == oTextHighlightCharacters[j].line &&
					oTextData[i].startingText.word == oTextHighlightCharacters[j].word &&
					oTextData[i].startingText.character == oTextHighlightCharacters[j].character) {
					bCharacterRemoved = true;
					break;
				}
			}

			// Remove the character if required.
			if (bCharacterRemoved) {
				oTextData.splice(i, 1);
				i--;
			}
		}

		// Return the result.
		return oTextData;
	};

	// Add the Text Tools tool object to the window.
	window.TextTools_RemoveTextHighlight = TextTools_RemoveTextHighlight;
}());